import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import {
  // AddProductAPI,
  // AddCompanyURLAPI,
  // AddModuleAPI,
  // addEmailCredentialApi,
  // addDbCredentialApi,
  // fetchEmailCredentialDetails,
  // fetchDbCredentialDetails,
  fetchUserDetails,
  getUserApproved,
  getuserReset,
  // clearStorage,
  // googleAuthcredentials,
  // getStaticIntegrations,
  // getIntegrations,
  // addIntegration,
  // deleteIntegrations,
  getUSerRoles,
  updateUserType,
  // getModulePermissions,
  // updateModulePerm,
} from "./../../API/adminAPI";
import { fetchProducts, fetchModules } from "./../../API/CreateCollectionAPI";

const User = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [userData, setUserData] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const [snackBarMsg, setSnackBarMsg] = useState("");
  const [savenextmessage, setsavenextmessage] = useState(false);
  const [format, setFormat] = useState("");
  const [productList, setproductList] = useState([]);

  const handleupdateUserType = async (iduserprofile, usertype) => {
    await updateUserType(iduserprofile, usertype)
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
        } else {
          const updatedUserData = userData.map((user) =>
            user.iduserprofile === iduserprofile ? { ...user, usertype } : user,
          );

          setUserData(updatedUserData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const userReset = async (id) => {
    await getuserReset(id)
      .then((response) => {
        if (response.status === 200) {
          console.log("userApproved", response);
          if (response.data.message === "fail") {
            console.log("error");
            setSnackBarMsg(response.data);
            setsavenextmessage(true);
            setFormat("error");
          } else {
            console.log("user reset", response);
            getUserData();
            // window.location.reload();
            setSnackBarMsg(response.data);
            setsavenextmessage(true);
            setFormat("success");
          }
        }
      })
      .catch((error) => {
        console.log("get user approved error", error);
      });
  };
  const getUserData = async (id) => {
    await fetchUserDetails(id)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
            console.log("error");
          }
          //   if (response.data[0].status == 3) {
          //     setUserData(response.data);
          //  }
          else {
            setUserData(response.data);
          }
        }
      })
      .catch((error) => {
        console.log("get user details error", error);
      });
  };
  // custom pagination
  function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  function createData(name, calories, fat) {
    return { name, calories, fat };
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userData.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getProducts = async (api_input) => {
    await fetchProducts(api_input)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
          } else {
            setproductList(response.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const userApproved = async (id) => {
    await getUserApproved(id)
      .then((response) => {
        if (response.status === 200) {
          console.log("userApproved", response);
          if (response.data.message === "fail") {
            console.log("error");
            setSnackBarMsg(response.data);
            setsavenextmessage(true);
            setFormat("error");
          } else {
            getUserData();
            // window.location.reload();
            setSnackBarMsg(response.data);
            setsavenextmessage(true);
            setFormat("success");
          }
        }
      })
      .catch((error) => {
        console.log("get user approved error", error);
      });
  };
  const handlegetUSerRoles = async () => {
    await getUSerRoles()
      .then((response) => {
        setUserRole(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getProducts();
    getUserData();
    handlegetUSerRoles();
  }, []);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow style={{ fontSize: "16px", fontWeight: "bold" }}>
            <TableCell>Username</TableCell>
            <TableCell align="right">First Name</TableCell>
            <TableCell align="right">Last Name</TableCell>
            <TableCell align="right">Phone</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">User Role</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? userData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : userData
          ).map((row) => (
            <TableRow
              key={row.iduserprofile}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.username}
              </TableCell>
              <TableCell align="right">{row.firstname}</TableCell>
              <TableCell align="right">{row.lastname}</TableCell>
              <TableCell align="right">{row.phonenumber}</TableCell>
              <TableCell align="right">{row.email}</TableCell>
              <TableCell align="right">
                <FormControl>
                  <Select
                    variant="standard"
                    value={
                      userRole.find((item) => item.iduser_roles === row.usertype)?.iduser_roles ||
                      ""
                    }
                    onChange={(event) => {
                      handleupdateUserType(row.iduserprofile, event.target.value);
                    }}
                  >
                    {userRole
                      .filter((item) => item.user_role === "SUPER" || item.user_role === "USER")
                      .map((item) => (
                        <MenuItem key={item.iduser_roles} value={item.iduser_roles}>
                          {item.user_role}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">
                {row.status === 3 ? (
                  <Button
                    variant="contained"
                    color="success"
                    title="Approve"
                    onClick={() => userApproved(row.iduserprofile)}
                  >
                    Approve
                  </Button>
                ) : row.status === 2 ? (
                  <Button
                    variant="contained"
                    color="secondary"
                    title="Approve"
                    onClick={() => userReset(row.iduserprofile)}
                  >
                    Reset
                  </Button>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={3}
              count={userData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default User;
